export { default } from "./SwiperShort"
